<script setup>
import {watch} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  answer: {
    type: String,
    required: true,
  },
  answerLength: {
    type: Number,
    required: true,
  },
  isAnswerValid: {
    type: Boolean,
    required: true,
  },
  choice: {
    type: Object,
    default: null,
  },
  errors: {
    type: Object,
    required: true,
  },
});
const emits = defineEmits(['set-answer']);
</script>

<template>
  <div class="lyMb24">
    <div class="lyHorizontalBreak lyMb8">
      <p class="lyMr8 pFont12">{{choice.title_reason}}</p>
      <p
        v-if="Number(choice.is_required_reason) !== 0"
        class="pFont10 pFontBold"
      >必須</p>
    </div>
    <p
      v-for="error in errors.value"
      class="lyMb8 pFont12 pFontMedium pFontRed">{{error}}</p>
    <div class="lyOverFlewHidden pBorderRadius2px">
      <textarea
        :value="answer"
        class="lyW100 lyPd8 pBackColorWhite"
        placeholder="入力してください。"
        rows="10"
        @input="$emit('set-answer', $event.target.value)"
      ></textarea>
      <div class="lyPd8 lyHorizontal pFont10 pBackColorWhite">
        <div :class="{lyHorizontal: true, pFontRed: ! isAnswerValid, pFontGreen: isAnswerValid}">
          <p class="lyMr4">現在</p>
          <p class="lyMr4">{{ new Intl.NumberFormat().format(answerLength) }}</p>
          <p class="lyMr4">文字入力</p>
        </div>
        <p class="pFontGray30">※最大1000文字入力可能</p>
      </div>
    </div>
  </div>
</template>